const devBaseURLConfig = process.env.REACT_APP_BASE_URL_CONFIG_DEV;
const devSSOURL = process.env.REACT_APP_BASE_URL_SSO_DEV;

const prodBaseURLConfig = process.env.REACT_APP_BASE_URL_CONFIG_PROD;
const prodSSOURL = process.env.REACT_APP_BASE_URL_SSO_PROD;

const isDevEnvironment = window.location.hostname === "localhost";

const baseURLConfig = isDevEnvironment ? devBaseURLConfig : prodBaseURLConfig;
const SSO_URL = isDevEnvironment ? devSSOURL : prodSSOURL;

export const inserirSubConta = async (nomeFarmacia) => {
  const obterToken = async () => {
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };

    const params = new URLSearchParams({
      grant_type: isDevEnvironment ? process.env.REACT_APP_DEV_GRANT_TYPE : process.env.REACT_APP_PROD_GRANT_TYPE,
      client_id: isDevEnvironment ? process.env.REACT_APP_DEV_CLIENT_ID : process.env.REACT_APP_PROD_CLIENT_ID,
      client_secret: isDevEnvironment ? process.env.REACT_APP_DEV_CLIENT_SECRET : process.env.REACT_APP_PROD_CLIENT_SECRET,
      scope: isDevEnvironment ? process.env.REACT_APP_DEV_SCOPE : process.env.REACT_APP_PROD_SCOPE,
      gmt: isDevEnvironment ? process.env.REACT_APP_DEV_GMT : process.env.REACT_APP_PROD_GMT,
    });

    try {
      const response = await fetch(SSO_URL, {
        method: 'POST',
        headers,
        body: params,
      });

      if (!response.ok) {
        throw new Error(`Erro ao obter token. Status: ${response.status}`);
      }

      const data = await response.json();
      return data.access_token;
    } catch (error) {
      console.error('Erro ao obter token:', error);
      return error;
    }
  };

  let token = await obterToken();

  const endpoint = `${baseURLConfig}/CriaSubConta`;

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ nomeFarmacia }),
    });


    if (!response.ok) {
      const errorData = await response.json();
      let parseMessage = errorData[0].message.slice(0, errorData[0].message.indexOf(' -')).trim();
      let parse = errorData[0].message.slice(errorData[0].message.indexOf('-') + 2).trim()
      let errorParse = JSON.parse(parse)
      return {
        Error: `Mensagem:${parseMessage} Erro: ${errorParse.message}\nInformação adicional: ${errorParse.more_info}\nStatus: ${response.status}`
      };
    }

    return await response.json();
  } catch (error) {
    console.error('Erro ao inserir sub-conta:', error);
    return { TypeError: error };
  }
};
export const criaRemetente = async (remetente) => {
  const obterToken = async () => {
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };

    const params = new URLSearchParams({
      grant_type: isDevEnvironment ? process.env.REACT_APP_DEV_GRANT_TYPE : process.env.REACT_APP_PROD_GRANT_TYPE,
      client_id: isDevEnvironment ? process.env.REACT_APP_DEV_CLIENT_ID : process.env.REACT_APP_PROD_CLIENT_ID,
      client_secret: isDevEnvironment ? process.env.REACT_APP_DEV_CLIENT_SECRET : process.env.REACT_APP_PROD_CLIENT_SECRET,
      scope: isDevEnvironment ? process.env.REACT_APP_DEV_SCOPE : process.env.REACT_APP_PROD_SCOPE,
      gmt: isDevEnvironment ? process.env.REACT_APP_DEV_GMT : process.env.REACT_APP_PROD_GMT,
    });

    try {
      const response = await fetch(SSO_URL, {
        method: 'POST',
        headers,
        body: params,
      });

      if (!response.ok) {
        return new Error(`Erro ao obter token. Status: ${response.status}`);
      }

      const data = await response.json();
      return data.access_token;
    } catch (error) {
      console.error('Erro ao obter token:', error);
      return error;
    }
  };

  let token = await obterToken();

  const endpoint = `${baseURLConfig}/CriaRemetente`;

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        senderId: remetente.senderId,
        wabaId: remetente.wabaId,
        authToken: remetente.authToken,
        sid: remetente.sid
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      let parseMessage = errorData[0].message.slice(0, errorData[0].message.indexOf(' -')).trim();
      let parse = errorData[0].message.slice(errorData[0].message.indexOf('-') + 2).trim()

      try {
        let errorParse = JSON.parse(parse);
        return {
          Error: `Mensagem:${parseMessage} Erro: ${errorParse.message}\nInformação adicional: ${errorParse.more_info}\nStatus: ${response.status}`
        };

      } catch {
        return {
          Error: `Mensagem:${parseMessage} Erro: Status do remetente diferente do esperado\nInformação adicional: ${parse}\nStatus: ${response.status}`
        };
      }
    }

    return await response.json();

  } catch (error) {
    console.error(error);
    return { TypeError: error };
  }
}